__webpack_require__.p = "/fatalities-dashboard/";